module.exports = __webpack_public_path__ + "img/21.4291c706.png";